// src/app/core/services/encryption.service.ts

import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  private readonly secretKey = environment.secretKey;

  encryptDeterministic(value: string): string {
    return CryptoJS.HmacSHA256(value, this.secretKey).toString();
  }

  encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.secretKey).toString();
  }

  decrypt(value: string): string {
    try {
      const bytes = CryptoJS.AES.decrypt(value, this.secretKey);

      return bytes.toString(CryptoJS.enc.Utf8);
    } catch {
      return '';
    }
  }

  decryptDeterministic(value: string): string {
    return value;
  }
}
